/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";

/**
 *
 * @export
 * @interface AcademicUserUpdateDTO
 */
export interface AcademicUserUpdateDTO {
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	name?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	description?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	personalEmail?: string | null;
	/**
	 *
	 * @type {StudentYearEnum}
	 * @memberof AcademicUserUpdateDTO
	 */
	year?: StudentYearEnum;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	externalFacultyName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	cvUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	linkedInUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	gitUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	siteUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	researchField?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	lowResImage?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	fullResImage?: string | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AcademicUserUpdateDTO
	 */
	skills?: Array<string> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AcademicUserUpdateDTO
	 */
	areasOfInterest?: Array<string> | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	departmentId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	facultyId?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserUpdateDTO
	 */
	group?: string | null;
}

export function AcademicUserUpdateDTOFromJSON(
	json: any
): AcademicUserUpdateDTO {
	return AcademicUserUpdateDTOFromJSONTyped(json, false);
}

export function AcademicUserUpdateDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AcademicUserUpdateDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		name: !exists(json, "name") ? undefined : json["name"],
		description: !exists(json, "description") ? undefined : json["description"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
		email: !exists(json, "email") ? undefined : json["email"],
		personalEmail: !exists(json, "personalEmail")
			? undefined
			: json["personalEmail"],
		year: !exists(json, "year")
			? undefined
			: StudentYearEnumFromJSON(json["year"]),
		externalFacultyName: !exists(json, "externalFacultyName")
			? undefined
			: json["externalFacultyName"],
		cvUrl: !exists(json, "cvUrl") ? undefined : json["cvUrl"],
		linkedInUrl: !exists(json, "linkedInUrl") ? undefined : json["linkedInUrl"],
		gitUrl: !exists(json, "gitUrl") ? undefined : json["gitUrl"],
		siteUrl: !exists(json, "siteUrl") ? undefined : json["siteUrl"],
		researchField: !exists(json, "researchField")
			? undefined
			: json["researchField"],
		lowResImage: !exists(json, "lowResImage") ? undefined : json["lowResImage"],
		fullResImage: !exists(json, "fullResImage")
			? undefined
			: json["fullResImage"],
		skills: !exists(json, "skills") ? undefined : json["skills"],
		areasOfInterest: !exists(json, "areasOfInterest")
			? undefined
			: json["areasOfInterest"],
		departmentId: !exists(json, "departmentId")
			? undefined
			: json["departmentId"],
		facultyId: !exists(json, "facultyId") ? undefined : json["facultyId"],
		group: !exists(json, "group") ? undefined : json["group"],
	};
}

export function AcademicUserUpdateDTOToJSON(
	value?: AcademicUserUpdateDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		name: value.name,
		description: value.description,
		phone: value.phone,
		email: value.email,
		personalEmail: value.personalEmail,
		year: StudentYearEnumToJSON(value.year),
		externalFacultyName: value.externalFacultyName,
		cvUrl: value.cvUrl,
		linkedInUrl: value.linkedInUrl,
		gitUrl: value.gitUrl,
		siteUrl: value.siteUrl,
		researchField: value.researchField,
		lowResImage: value.lowResImage,
		fullResImage: value.fullResImage,
		skills: value.skills,
		areasOfInterest: value.areasOfInterest,
		departmentId: value.departmentId,
		facultyId: value.facultyId,
		group: value.group,
	};
}
